import { atom } from 'jotai'

export const showAttachmentInInspectorAtom = atom<null | string>(null)
